import _ from 'lodash';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { KEYSTONE_EVENT_SET_CLIENT_USAGE, SHOW_LOADING_SPINNER } from '../actions/keystoneEventActionCreator';

const defaultState = {
  isLoaded: false,
  isLoading: false,
  event: {},
  clientUsage: {}
};

export default function keystoneEventReducer(
  state: any = _.cloneDeep(defaultState),
  action: TAction<any>
): Partial<any> {
  switch (action.type) {
    case KEYSTONE_EVENT_SET_CLIENT_USAGE: {
      return {
        ...state,
        event: {
          ...(state.event ? state.event : {}),
          ...action.payload.keystoneEvent
        },
        clientUsage: {
          ...(state.clientUsage ? state.clientUsage : {}),
          ...{ users: action.payload.users }
        },
        isLoading: false,
        isLoaded: true
      };
    }
    case SHOW_LOADING_SPINNER: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    default:
      return state;
  }
}
